import { Fragment, FunctionComponent } from 'react';
import { Link } from 'react-router';
import PaperLayout from '../layout/PaperLayout';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { useNavigationPaths } from '../propertyAssociation/useNavigationPaths';
import NoMessages from './components/NoPinboardMessages';
import PinboardMessageItem from './components/PinboardMessageItem';
import PinboardMessageList from './components/PinboardMessageList';
import { PinboardMessage } from './models/GetPinboardMessagesResponse';
import { usePinboardMessages } from './pinboardMessageService';

const PinboardMessages: FunctionComponent = () => {
    const { currentFunctionPermissions, isRBHyr } = usePropertyAssociationContext();
    const paths = useNavigationPaths();
    const { response, isLoading } = usePinboardMessages();

    const pinboardMessages = (response?.results as unknown as PinboardMessage[]) || [];
    const canCreateNew = currentFunctionPermissions?.createPinboardMessage || false;
    const title = isRBHyr ? 'Hyresvärden informerar' : 'Styrelsen informerar';

    return (
        <Fragment>
            <PaperLayout heading={title} tightenUp={true} mainClass="pt-4" preamble={<p>Här visas meddelanden som publicerats under {title} i Mitt Riksbyggen.</p>}>
                {canCreateNew && (
                    <div className="d-flex mb-4 pb-2">
                        <Link to={`${paths.adverts}/information/create`} className="btn btn-lg btn-primary ms-auto">
                            Skapa inlägg
                        </Link>
                    </div>
                )}
                {isLoading && (
                    <div className="paper__message  paper__message--large">
                        <div className="paper__subheading text-center">Hämtar meddelanden...</div>
                    </div>
                )}
                {!isLoading && pinboardMessages.length <= 0 && <NoMessages />}
                {!isLoading && pinboardMessages.length > 0 && (
                    <PinboardMessageList>
                        {pinboardMessages.map((item) => (
                            <PinboardMessageItem key={item.pinboardMessageId} {...item} />
                        ))}
                    </PinboardMessageList>
                )}
            </PaperLayout>
        </Fragment>
    );
};

export default PinboardMessages;
